export default "__VITE_ASSET__Ct7t8WfS__"